import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import { withClassname } from '@components/hoc/withClassname';
import { withConfiguration } from '@components/hoc/withConfiguration';

import { deleteTicket } from '@modules/tickets/_ticketsActions';
import { TicketsForm } from '@modules/tickets/TicketsForm';
import { ActionBar } from '@modules/tickets/TicketsGridButtons';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withNotifications } from '@components/hoc/withNotifications';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { parseBool } from '@utils/utils';
import { get } from 'lodash';

export const ticketsUrl = '/metropolis/api/ed/tickets/dto';
export const ticketsLabel = 'Bloky';
export const ticketsPath = '/tickets';
export const ticketsGridName = 'TicketsGrid';

export const TicketsGrid = compose(
  withConfiguration({}),
  withRouter,
  withNotifications({ deleteTicket }),
  setDisplayName(ticketsGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: ticketsLabel }]),
  withColumns(Agenda.TICKETS),
  withProps(({ history, deleteTicketNotify, columns, config: { extensions } }) => ({
    name: ticketsGridName,
    url: ticketsUrl,
    Form: TicketsForm,
    dialog: false,
    deleteItems: deleteTicketNotify,
    gridProps: {
      columns,
      history,
      ActionBar,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      allowRestore: () => parseBool(get(extensions, 'ticketrestore', false)),
      sort: 'created',
      locale: 'cz',
      adding: false,
      pageSize: 50,
      version: 9
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/tickets/TicketsGrid.tsx